import '../../Styles/CommunityStyles/community.css'
import bro from '../../Assets/bro.png'

export default function Cummunity() {
  return (
    <div className='Community'>
        <div className="CommunityContainer">
          <div className="CommunityHeading">join oru community</div>
        <div className="communitytop">
        <div className="Communityleft">
          <div className="leftContainer">
            <div>
              🌟 Welcome to the heart of our Supix universe! 🌐 Join our vibrant community of art enthusiasts,<br/>
              collectors, and creators who share a passion for the extraordinary. By becoming a part of our<br/>
              community, you gain exclusive access to: 
            </div>
            <div>
              🎨 Unique Creations: Dive into a world of one-of-a-kind digital artworks and collectibles<br/>
              crafted by talented artists. 
            </div>
            <div>
              🤝 Connect with Like Minds: Engage in lively discussions, exchange ideas, and connect with<br/>
              fellow members who appreciate the beauty of digital art. 
            </div>
            <div>
              🚀 Early Access & Special Events: Be the first to explore new releases, participate in exclusive<br/>
              events, and enjoy perks reserved just for our community members. 
            </div>
            <div>
              🌈 A Thriving Ecosystem: Experience the synergy of creativity and innovation as our<br/>
              community collaborates and grows together. 
            </div>
          </div>
        </div>
        <div className="communityRight">
          <img src={bro} alt="" />
        </div>
    </div>
    </div>
    </div>
  )
}
